'use client'

import { useEffect } from 'react'

interface EnquiryPopupProps {
  isOpen: boolean
  setIsOpen: (v: boolean) => void
}

export default function EnquiryPopup({ isOpen, setIsOpen }: EnquiryPopupProps) {
  const closePopup = () => setIsOpen(false)

  // 弹窗打开时禁止滚动
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-sm md:max-w-md p-6 relative max-h-[90vh] overflow-auto">
        {/* 关闭按钮 */}
        <button
          onClick={closePopup}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 cursor-pointer text-xl"
        >
          ✕
        </button>

        {/* 表单 */}
        <form action="https://formspree.io/f/mqallbaq" method="POST" className="space-y-4 w-full">
          <h3 className="text-left font-bold text-black text-2xl font-Ovo leading-relaxed">
            Enquiry Form
          </h3>

          <div>
            <label className="block text-sm font-medium text-left text-gray-700">Your Name</label>
            <input
              type="text"
              name="name"
              required
              className="mt-1 p-3 w-full border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-gray-900"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-left text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              required
              className="mt-1 p-3 w-full border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-gray-900"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-left text-gray-700">Message</label>
            <textarea
              name="message"
              rows={6}
              required
              className="mt-1 p-3 w-full border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 placeholder-gray-400"
              placeholder="Type your message here..."
            />
          </div>

          <button
            type="submit"
            className="bg-black hover:bg-white text-white hover:text-black font-semibold py-3 px-6 rounded-lg transition duration-300 w-full cursor-pointer"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  )
}


